module.exports = __webpack_public_path__ + "img/2.fae0868d.png";